import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
      closestSection.addEventListener('change', this.updateInstantPrice, true);
}

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
      closestSection.removeEventListener('change', this.updateInstantPrice, true);
}
  updateInstantPrice = (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const picker = event.target.closest('variant-picker');
    if (
      !picker ||
      picker.dataset.templateProductMatch !== 'true' ||
      picker.dataset.productId !== this.dataset.productId ||
      picker.closest('product-card, quick-add-component, dialog')
    ) return;

    const groups = Array.from(
      picker.querySelectorAll('.variant-option')
    );

    const values = groups.map((group) => {
      const select = group.querySelector('select');
      if (select) return select.value;

      const radio = group.querySelector('input[type="radio"]:checked');
      return radio?.value ?? '';
    });

    if (!values.length || values.some((value) => value === '')) return;

    const templates = this.querySelectorAll('template[data-instant-price]');
    const matchingTemplate = Array.from(templates).find((template) => {
      try {
        const options = JSON.parse(template.dataset.options);
        return options.length === values.length &&
          options.every((option, index) => option === values[index]);
      } catch {
        return false;
      }
    });

    if (!matchingTemplate) return;

    const preparedPrice = matchingTemplate.content
      .querySelector('[ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!preparedPrice || !currentPrice) return;

    const newPrice = preparedPrice.cloneNode(true);
    currentPrice.replaceWith(newPrice);

    for (const name of [
      'updateToHeaderButtonPrice',
      'contentUpdate',
      'contentUpdateTop'
    ]) {
      try {
        if (typeof globalThis[name] === 'function') {
          globalThis[name](newPrice);
        }
      } catch (error) {
        console.warn('Instant price display update failed', error);
      }
    }
  };



  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */

  

  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }

    // Safely call global functions with error handling
    try {
      // @ts-ignore - Accessing global function
      if (globalThis.updateToHeaderButtonPrice && typeof globalThis.updateToHeaderButtonPrice === 'function') {
        // @ts-ignore - Calling global function
        globalThis.updateToHeaderButtonPrice(newPrice);
      }
    } catch (error) {
      console.warn('Error calling updateToHeaderButtonPrice:', error);
    }

    try {
      // @ts-ignore - Accessing global function
      if (globalThis.contentUpdate && typeof globalThis.contentUpdate === 'function') {
        // @ts-ignore - Calling global function
        globalThis.contentUpdate(newPrice);
      }
    } catch (error) {
      console.warn('Error calling contentUpdate:', error);
    }

    try {
      // @ts-ignore - Accessing global function
      if (globalThis.contentUpdateTop && typeof globalThis.contentUpdateTop === 'function') {
        // @ts-ignore - Calling global function
        globalThis.contentUpdateTop(newPrice);
      }
    } catch (error) {
      console.warn('Error calling contentUpdateTop:', error);
    }
    // console.log('Price updated to:', newPrice.textContent);

  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
  
}
